const url = process.env.REACT_APP_URL || `https://${window.location.host}`

export const getImageUrl = (location) => {
    return location && `${url}${location}`
}
